import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';

const ModalAtualizacao = ({
  vinculoSelecionado,
  mostrarModal,
  setMostrarModalAtualizacao,
  cpf,
  buscarProspecto,
}) => {
  const [carregando, setCarregando] = useState(false);

  const cores = {
    red: '#f8d7da',
    green: '#d4edda',
  };
  const textColors = {
    red: '#721c24',
    green: '#155724',
  };

  const gerarPill = (valor, cor) => (
    <span
      style={{
        backgroundColor: cores[cor],
        color: textColors[cor],
        padding: '2px 8px',
        borderRadius: '10px',
        margin: '0 4px',
        display: 'inline-block',
        fontWeight: 'bold',
      }}
    >
      {valor}
    </span>
  );

  const atualizarProspectoGes = async () => {
    try {
      setCarregando(true);
      const response = await api.atualizarProspectoGES({
        ge: vinculoSelecionado.codigo_grupo_empresa,
        codigo_cliente_joia: vinculoSelecionado.codigo_prospecto_cliente_joia,
        codigo_prospecto: vinculoSelecionado.codigo_prospecto,
        cpf: cpf,
      });
      if (response) {
        toast.info(response.message);
        buscarProspecto(vinculoSelecionado.codigo_prospecto);
        setMostrarModalAtualizacao(false);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Modal
      size="md"
      backdrop="static"
      show={mostrarModal}
      onHide={() => setMostrarModalAtualizacao(false)}
      centered
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title className="text-center">
          <div className="text-center mt-2">
            <span className="d-block">Atenção!</span>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-left py-4">
        <p className="mb-3">Deseja atualizar vínculo do prospecto no GES?</p>
        {vinculoSelecionado && (
          <div>
            <div>
              <p className="mb-2">
                <strong>Nome Cliente: </strong>{' '}
                {vinculoSelecionado.nome_cliente_joia}
              </p>
            </div>
            <p className="mb-2">
              <strong>Conta: </strong>{' '}
              {vinculoSelecionado.codigo_conta || 'Sem conta'} |{' '}
              <strong>GE: </strong>{' '}
              {vinculoSelecionado.codigo_grupo_empresa || 'Sem GE'}
            </p>
            <>
              <div style={{ marginTop: '12px' }}>
                <strong>Código Prospecto: </strong>
                {gerarPill(
                  vinculoSelecionado.codigo_prospecto_cliente_joia,
                  'red'
                )}
                →{gerarPill(vinculoSelecionado.codigo_prospecto, 'green')}
              </div>
              <div
                style={{
                  marginTop: '8px',
                  fontSize: '0.85em',
                  color: '#666',
                }}
              >
                <span style={{ color: textColors.red }}>■</span> Código
                Prospecto GES →{' '}
                <span style={{ color: textColors.green }}>■</span> Código
                Prospecto Extranet
              </div>
            </>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button
          variant="secondary"
          onClick={() => setMostrarModalAtualizacao(false)}
          disabled={carregando}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={atualizarProspectoGes}
          disabled={carregando}
        >
          {carregando ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>{' '}
              Atualizando...
            </>
          ) : (
            'Confirmar'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAtualizacao;
